import { ReactText } from 'react';
import { actionCreatorFactory } from '../../core/utils/factories';
import {
  EquipmentModal,
  FinancialData,
  LeasingBrowseResponseItem,
  LeasingEquipmentResp,
  LeasingEquipmentTabData,
  LeasingEquipmentUpdateData,
  LeasingLeaseAuditTabData,
  LeasingSummaryTabData,
  LeasingWorkflowTabData,
  LeasingWorkflowUpdateData,
  PaginatedResponse,
  PermittingJurisdictionAuditData,
} from '../../models/interfaces';
import {
  LeasingEquipmentData,
  LeasingLeaseAuditUpdateData,
} from '../../models/types';

export type LeasingStateTableKey = keyof Omit<
  LeasingEquipmentData,
  'scopingNotes' | 'priorLeasingNote' | 'finalLeasingNote'
>;

export type LeasingActionType = {
  data: EquipmentModal;
  key: LeasingStateTableKey;
};

const actionCreator = actionCreatorFactory('LEASING');

export namespace LeasingActions {
  export const getLeasingBrowseDataAction =
    actionCreator.createAsyncAction<
      PaginatedResponse<LeasingBrowseResponseItem>
    >('GET_LEASING_BROWSE');
  export const getLeasingEquipmentPriorProjectAction =
    actionCreator.createAsyncAction<LeasingEquipmentResp>(
      'GET_LEASING_EQUIPMENT_PRIOR_PROJECT',
    );
  export const updateLeasingWorkflowAction =
    actionCreator.createAsyncAction<LeasingWorkflowUpdateData>(
      'UPDATE_LEASING_WORKFLOW',
    );
  export const updateLeasingEquipmentAction =
    actionCreator.createAsyncAction<LeasingEquipmentUpdateData>(
      'UPDATE_LEASING_EQUIPMENT',
    );
  export const updateLeaseAuditAction = actionCreator.createAsyncAction<
    Partial<LeasingLeaseAuditUpdateData> & { area: 'engineering' | 'leasing' }
  >('UPDATE_LEASE_AUDIT');
  export const addTableItemAction =
    actionCreator.createAsyncAction<LeasingActionType>('ADD_TABLE_ITEM');
  export const editTableItemAction =
    actionCreator.createAsyncAction<LeasingActionType>('EDIT_TABLE_ITEM');
  export const deleteTableItemAction =
    actionCreator.createAsyncAction<LeasingActionType>('DELETE_TABLE_ITEM');
  export const emptyPriorTableAction =
    actionCreator.createAsyncAction<null>('EMPTY_PRIOR_TABLE');
  export const generateFinalLoadingAction = actionCreator.createAsyncAction<
    ReactText[]
  >('GENERATE_FINAL_LOADING');
  export const resetTablesDataAction =
    actionCreator.createAsyncAction<null>('RESET_TABLES_DATA');
  // Per-tab data loading
  export const getSummaryTabDataAction =
    actionCreator.createAsyncAction<LeasingSummaryTabData>(
      'GET_SUMMARY_TAB_DATA',
    );
  export const getWorkflowTabDataAction =
    actionCreator.createAsyncAction<LeasingWorkflowTabData>(
      'GET_WORKFLOW_TAB_DATA',
    );
  export const getLeaseAuditTabDataAction =
    actionCreator.createAsyncAction<LeasingLeaseAuditTabData>(
      'GET_LEASE_AUDIT_TAB_DATA',
    );
  export const getEquipmentTabDataAction =
    actionCreator.createAsyncAction<LeasingEquipmentTabData>(
      'GET_EQUIPMENT_TAB_DATA',
    );
  export const getJurisdictionAuditTabData =
    actionCreator.createAsyncAction<PermittingJurisdictionAuditData>(
      'GET_JURISDICTION_AUDIT_TAB_DATA',
    );
  export const getFinancialTabData =
    actionCreator.createAsyncAction<FinancialData>('GET_FINANCIAL_TAB_DATA');
  export const setTabLoading = actionCreator.createAsyncAction<{
    tabName: string;
    isLoading: boolean;
  }>('SET_TAB_LOADING');
  export const resetTabsData =
    actionCreator.createAsyncAction('RESET_TABS_DATA');
}
